import { Practice } from '../UserPages/Login/PracticeRegistration/Model/Practice';
import { PracticeLocationData } from '../UserPages/Login/PracticeRegistration/Model/PracticeLocationData';
import Helpers from '../../utils/helper';

export const convertOwnersPracticeToFrontend = (
    ownersPractice: string | number
): string => {
    if (typeof ownersPractice === 'number') {
        return ownersPractice.toString();
    }

    switch (ownersPractice) {
        case 'ft':
            return '1';
        case 'pt':
            return '2';
        default:
            return '0';
    }
};

export const convertOwnersPracticeToBackend = (
    ownersPractice: string
): string => {
    switch (ownersPractice) {
        case '1':
            return 'ft';
        case '2':
            return 'pt';
        default:
            return 'no';
    }
};

export interface UserSummaryPracticeDTO {
    id?: number;
    practiceId?: number;
    practiceRegId?: number;
    name: string;
    ownerName: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    principalOwnerPhone: string;
    noofOwners: number;
    noOfFteDvms: number;
    practiceFteDvmNumber?: number;
    ownersPractice: string;
    practiseTypeID: number;
    otherPracticeType?: string;
    website: string;
    users: number[];
    groupId: number;
    status: number;
    practiceGroupStatus?: number;
    hasFreeReportBeenCreated: boolean;
    practiceOwnershipType: number;
    isServiceSubscriptionExists: boolean;
    ownershipStartDate?: Date;
    ownershipEndDate?: Date;
    roleInPractice: string;
    hasEquity: boolean;
    isInEngagement: boolean;
    practiceLocationData: PracticeLocationData[];
    ownedPracticeSince?: number;
    ltmRevenue?: number;
}

export const convertUserSummaryToPractice = (
    userSummary: UserSummaryPracticeDTO
): Practice => {
    const practiceLocationData = userSummary.practiceLocationData || [];

    if (practiceLocationData.length === 0 && userSummary.address) {
        practiceLocationData.push({
            practiceLocationName: userSummary.name,
            phone: Helpers.trimPhoneNumberFromMask(userSummary.principalOwnerPhone),
            website: userSummary.website,
            address: userSummary.address,
            city: userSummary.city,
            state: userSummary.state,
            zipCode: userSummary.zipCode,
            fteDvm: userSummary.noOfFteDvms || 0,
            practiceFocus: userSummary.practiseTypeID || 0,
            otherPracticeType: userSummary.otherPracticeType,
        });
    }

    return {
        practiceId: userSummary.practiceId || 0,
        name: userSummary.name,
        principalOwnerPhone: Helpers.trimPhoneNumberFromMask(userSummary.principalOwnerPhone),
        msa: '',
        city: userSummary.city,
        state: userSummary.state,
        zipCode: userSummary.zipCode,
        website: userSummary.website,
        noOfOwners: userSummary.noofOwners,
        noOfFteDvms: userSummary.noOfFteDvms,
        practiceFteDvmNumber: userSummary.practiceFteDvmNumber,
        practiceFocus: userSummary.practiseTypeID,
        otherPracticeType: userSummary.otherPracticeType,
        ownersPractice: convertOwnersPracticeToFrontend(
            userSummary.ownersPractice
        ),
        ownedPracticeSince: userSummary.ownedPracticeSince || 0,
        numberOfLocations: practiceLocationData.length,
        practiceLocationData: practiceLocationData.map((location) => ({
            ...location,
            phone: Helpers.trimPhoneNumberFromMask(location.phone),
        })),
        ltmRevenue: userSummary.ltmRevenue,
    };
};

export const convertPracticeToUserSummary = (
    practice: Practice,
    originalUserSummary: UserSummaryPracticeDTO
): UserSummaryPracticeDTO => {
    const firstLocation = practice.practiceLocationData?.[0];

    const trimmedLocations = (practice.practiceLocationData || []).map(
        (location) => ({
            ...location,
            phone: Helpers.trimPhoneNumberFromMask(location.phone),
        })
    );

    const result: UserSummaryPracticeDTO = {
        ...originalUserSummary,
        practiceId: practice.practiceId,
        name: practice.name,
        principalOwnerPhone: Helpers.trimPhoneNumberFromMask(practice.principalOwnerPhone),
        address: firstLocation?.address || originalUserSummary.address,
        city: practice.city,
        state: practice.state,
        zipCode: practice.zipCode,
        website: practice.website,
        noOfFteDvms: practice.noOfFteDvms,
        practiceFteDvmNumber: practice.practiceFteDvmNumber,
        practiseTypeID: practice.practiceFocus,
        otherPracticeType: practice.otherPracticeType,
        ownersPractice: convertOwnersPracticeToBackend(practice.ownersPractice),
        noofOwners: practice.noOfOwners,
        practiceLocationData: trimmedLocations,
        ownedPracticeSince: practice.ownedPracticeSince,
        ltmRevenue: practice.ltmRevenue,
    };

    return result;
};
